export default "__VITE_ASSET__DFMNDmml__"